<script>

export default {
    name: "ConsultantItemsForm",

    data() {

        return {
            items: [],
            consultantItem: {
                itemName: '',
                status: true,
                username: this.$root.username,
            },
        };
    },

    methods: {

        fetchSearchedItems() {

            if(!this.consultantItem.itemName) return;
            this.$root.loading = true;
            this.$http.get(`MasterData/GetNotConsultantItemsSearch?SearchText=${this.consultantItem.itemName}`).then(response => {
                this.items = response.data;
                this.$root.loading = false;
            }).catch(() => { this.$root.loading = false; });
        },

        saveData() {
            this.$root.loading = true;
            this.$http.post(`MasterData/ConsultantItems`, this.consultantItem).then(response => {
                this.consultantItem = { username: this.$root.username, status: true, itemName: ''};
                this.$root.loading = false;
                window.Swal.fire({type: 'success', title: response.data });
                this.$emit('refreshData');
            }).catch(() => { this.$root.loading = false; });
        },
    },
}
</script>
<template>
    <div class="flex flex-wrap">
        <div class="w-1/4 p-tiny">
            <label for="grid-item-select" class="label-control">Service/Item:</label>
            <input type="text" placeholder="press enter to search" v-on:keyup.enter="fetchSearchedItems" v-model="consultantItem.itemName" id="grid-item-select" class="input-control input-sm text-xs">
        </div>
        <div class="w-1/4 p-tiny">
        <tail-select>
            <template v-slot:field>
                <select id="grid-item" v-model="consultantItem.itemId" class="input-sm input-control text-xs mt-4">
                    <option v-for="(item, idx) in items" :value="item.itemID" :key="idx">{{ item.itemName }}</option>
                </select>
            </template>
        </tail-select>
        </div>
        <div class="w-1/4 p-tiny">
            <label for="grid-description" class="label-control">Description:</label>
            <textarea  id="grid-description" v-model="consultantItem.description" class="input-control input-sm text-xs" cols="3" rows="1"></textarea>
        </div>
        <div class="w-1/12 p-tiny mt-4">
            <label for="grid-status" class="label-control ">Active <input type="checkbox" v-model="consultantItem.status" id="grid-status"></label>
        </div>
        <div class="w-1/12 p-tiny mt-3">
            <button class="btn-primary btn-sm text-xs rounded" @click.prevent="saveData">
                <i class="fa fa-plus"></i> Item</button>
        </div>
    </div>
</template>
